import { _AccountCreateModel } from '../interfaces/requestCreateModels/_AccountCreateModel';

export class AccountCreateModel extends _AccountCreateModel{

}